import { apiCall } from '../../services/api';
import { addError } from './errors';
import { addSuccess } from './success';
import {
	LOAD_GROUP_DEALS,
	LOAD_GROUP_DEAL,
	CREATE_GROUP_DEAL,
	UPDATE_GROUP_DEAL,
	REMOVE_GROUP_DEAL,
	GROUP_DEALS_LOADING,
	GROUP_DEALS_ERROR,
} from '../actionTypes';

// loading state
export const setGroupDealsLoading = () => ({
	type: GROUP_DEALS_LOADING,
});

// local reducer error state
export const setGroupDealsError = (error) => ({
	type: GROUP_DEALS_ERROR,
	error,
});

// load all deals for one business
export const loadGroupDeals = (deals) => ({
	type: LOAD_GROUP_DEALS,
	deals,
});

// load single deal details
export const loadGroupDeal = (deal) => ({
	type: LOAD_GROUP_DEAL,
	deal,
});

// create one deal
export const createGroupDeal = (deal) => ({
	type: CREATE_GROUP_DEAL,
	deal,
});

// update one deal
export const updateGroupDeal = (deal) => ({
	type: UPDATE_GROUP_DEAL,
	deal,
});

// remove one deal from store
export const removeGroupDeal = (dealId) => ({
	type: REMOVE_GROUP_DEAL,
	dealId,
});

// GET /api/deals/:businessId/group-deals
export const fetchGroupDeals = (businessId) => async (dispatch) => {
	try {
		dispatch(setGroupDealsLoading());

		const res = await apiCall('get', `/api/deals/${businessId}/group-deals`);

		dispatch(loadGroupDeals(res));
		return res;
	} catch (err) {
		const message =
			err?.response?.data?.message ||
			err?.message ||
			'Failed to load group deals';

		dispatch(setGroupDealsError(message));
		dispatch(addError(message));
	}
};

// GET /api/deals/:businessId/group-deals/:dealId
export const fetchGroupDealDetails =
	(businessId, dealId) => async (dispatch) => {
		try {
			dispatch(setGroupDealsLoading());

			const res = await apiCall(
				'get',
				`/api/deals/${businessId}/group-deals/${dealId}`,
			);

			dispatch(loadGroupDeal(res));
			return res;
		} catch (err) {
			const message =
				err?.response?.data?.message ||
				err?.message ||
				'Failed to load deal details';

			dispatch(setGroupDealsError(message));
			dispatch(addError(message));
		}
	};

// POST /api/deals/:businessId/group-deals
export const postGroupDeal = (businessId, formData) => async (dispatch) => {
	try {
		dispatch(setGroupDealsLoading());

		const res = await apiCall(
			'post',
			`/api/deals/${businessId}/group-deals`,
			formData,
		);

		dispatch(createGroupDeal(res));
		dispatch(addSuccess('Group deal created successfully'));
		return res;
	} catch (err) {
		const message =
			err?.response?.data?.message ||
			err?.message ||
			'Failed to create group deal';

		dispatch(setGroupDealsError(message));
		dispatch(addError(message));
		throw err;
	}
};

// PATCH /api/deals/:businessId/group-deals/:dealId
export const patchGroupDeal =
	(businessId, dealId, formData) => async (dispatch) => {
		try {
			dispatch(setGroupDealsLoading());

			const res = await apiCall(
				'patch',
				`/api/deals/${businessId}/group-deals/${dealId}`,
				formData,
			);

			dispatch(updateGroupDeal(res));
			dispatch(addSuccess('Group deal updated successfully'));
			return res;
		} catch (err) {
			const message =
				err?.response?.data?.message ||
				err?.message ||
				'Failed to update group deal';

			dispatch(setGroupDealsError(message));
			dispatch(addError(message));
			throw err;
		}
	};

// PATCH /api/deals/:businessId/group-deals/:dealId/publish
export const publishGroupDeal = (businessId, dealId) => async (dispatch) => {
	try {
		dispatch(setGroupDealsLoading());

		const res = await apiCall(
			'patch',
			`/api/deals/${businessId}/group-deals/${dealId}/publish`,
		);

		dispatch(updateGroupDeal(res));
		dispatch(addSuccess('Group deal published successfully'));
		return res;
	} catch (err) {
		const message =
			err?.response?.data?.message ||
			err?.message ||
			'Failed to publish group deal';

		dispatch(setGroupDealsError(message));
		dispatch(addError(message));
		throw err;
	}
};

// PATCH /api/deals/:businessId/group-deals/:dealId/cancel
export const cancelGroupDeal = (businessId, dealId) => async (dispatch) => {
	try {
		dispatch(setGroupDealsLoading());

		const res = await apiCall(
			'patch',
			`/api/deals/${businessId}/group-deals/${dealId}/cancel`,
		);

		dispatch(updateGroupDeal(res));
		dispatch(addSuccess('Group deal cancelled successfully'));
		return res;
	} catch (err) {
		const message =
			err?.response?.data?.message ||
			err?.message ||
			'Failed to cancel group deal';

		dispatch(setGroupDealsError(message));
		dispatch(addError(message));
		throw err;
	}
};
